import React, { useState } from 'react';
import Grid from '@mui/material/Grid';
import SideBarContainer from 'Containers/SideBarContainer';
import FilterContainer from 'Containers/FilterContainer';
import useTranslation from 'Hooks/useTranslation';
import Title from 'Components/Title';
import Search from 'Components/Search';
import Dropdown from 'Components/DropDown';
import BasicTable from 'Components/BasicTable';
import MyCourseCard from 'Components/CourseCard';
import Toogle from 'Components/Toogle';
import LoadingContainer from 'Containers/LoadingContainer';
import useFetch, { STATUS_OPTIONS } from './Hooks/useFetch';
import useComponent from './Hooks/useComponent';

import { ListMyCourses, dropdownStyle, ContainerTable } from './style';

export default function MyCourses() {
  const { t2 } = useTranslation('MyCourses');
  const [isLoading, setIsLoading] = useState(true);
  const { courses, categories, setCategory, setName, setStatus, setIscard, isCard } = useFetch(setIsLoading);
  const { thereIsComponent, colorCategory, sendToCourseDetails } = useComponent({
    courses,
    categories,
  });

  return (
    <SideBarContainer>
      <Title title={t2('Title')} />
      <FilterContainer>
        <Grid item xs={4} style={{ paddingLeft: '0' }}>
          <Search placeholder={t2('Search')} setData={setName} />
        </Grid>
        <Grid item xs={8} style={dropdownStyle}>
          <Dropdown title={t2('Category')} setData={setCategory} options={categories} />
          <Dropdown
            title={t2('Status')}
            setData={value => {
              const found = STATUS_OPTIONS.find(s => s.name === value);
              setStatus(found ? found.id : null);
            }}
            options={STATUS_OPTIONS.map(s => s.name)}
          />
          <Toogle value={isCard} onclick={setIscard} />
        </Grid>
      </FilterContainer>
      {isCard ? (
        <FilterContainer>
          {courses.length === 0 ? (
            <LoadingContainer isLoading={isLoading}>{t2('NoData')}</LoadingContainer>
          ) : (
            <ListMyCourses>
              {courses &&
                courses.map((course, _) => (
                  <MyCourseCard
                    key={course[course.length - 2]}
                    title={course[0]}
                    description={course[1]}
                    image={course[6] === '' ? null : course[6]}
                    category={course[3]}
                    userCreatedName={course[4]}
                    userImage={course[5]}
                    colorCategory={colorCategory[course[3]]}
                    status={course[course.length - 1]}
                    editEvent={null}
                    clickAction={() => sendToCourseDetails(course)}
                  />
                ))}
            </ListMyCourses>
          )}
        </FilterContainer>
      ) : (
        <ContainerTable>
          <BasicTable
            information={courses}
            headers={[t2('TableTitle'), t2('Description'), t2('Priority'), t2('Category'), t2('CreatedBy')]}
            limit={5}
            thereIsComponent={thereIsComponent}
            widthColumn="25%"
            clickable
            clickAction={sendToCourseDetails}
            isLoading={isLoading}
          />
        </ContainerTable>
      )}
    </SideBarContainer>
  );
}
